import { Component } from '@angular/core';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({ standalone: false,
  selector: 'mx-table-caption',
  templateUrl: './mx.table-caption.component.html',
  styleUrls: ['./mx.table-caption.component.scss'],
})
export class MxTableCaptionComponent extends MxBaseComponent {}
